import styled from 'styled-components';

export const CloseButtonWrapper = styled.div`
  text-align: right;
`;
export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
`;